var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { I18N } from 'aurelia-i18n';
import { autoinject, transient } from "aurelia-dependency-injection";
import { LookupValueQuery, LookupValueRequest } from '../../../models/lookups/lookup.models';
import * as Enumerable from 'linq';
import { LotteryHelper } from '../../app/client/utilities/lottery-string-helper';
import { LookupClientService } from '../../../services/lookups/lookup-client.service';
var FromAssetsValueConverter = /** @class */ (function () {
    function FromAssetsValueConverter(i18n) {
        this.i18n = i18n;
    }
    FromAssetsValueConverter.prototype.toView = function (value, lotteries, asset, size) {
        if (value) {
            var lottery = LotteryHelper.getLotteryByKey(lotteries, this.i18n.tr(value));
            if (lottery) {
                var lotteryKey = LotteryHelper.getLotteryKey(lottery.lotteryName);
                return size ? this.i18n.tr(lotteryKey + '-' + asset + '-' + size) : this.i18n.tr(lotteryKey + '-' + asset);
            }
            return "";
        }
        else {
            return "";
        }
    };
    FromAssetsValueConverter = __decorate([
        autoinject,
        transient(),
        __metadata("design:paramtypes", [I18N])
    ], FromAssetsValueConverter);
    return FromAssetsValueConverter;
}());
export { FromAssetsValueConverter };
var CurrencyValueConverter = /** @class */ (function () {
    function CurrencyValueConverter(lookupClientService) {
        this.lookupClientService = lookupClientService;
    }
    CurrencyValueConverter.prototype.toView = function (value) {
        var _this = this;
        if (value) {
            if (!this.currencies) {
                var lookupRequest = new LookupValueRequest();
                lookupRequest.lookupValueQuery = LookupValueQuery.currencies;
                this.lookupClientService.getLookup(lookupRequest).then(function (x) {
                    _this.currencies = x.values;
                    var currencyEnumerable = Enumerable.from(_this.currencies);
                    var lookupValue = currencyEnumerable.firstOrDefault(function (x) { return x.id == Number(value); });
                    return lookupValue.additionalData['symbol'];
                });
            }
            else {
                var currencyEnumerable = Enumerable.from(this.currencies);
                var lookupValue = currencyEnumerable.firstOrDefault(function (x) { return x.id == Number(value); });
                return lookupValue.additionalData['symbol'];
            }
        }
    };
    CurrencyValueConverter = __decorate([
        autoinject,
        transient(),
        __metadata("design:paramtypes", [LookupClientService])
    ], CurrencyValueConverter);
    return CurrencyValueConverter;
}());
export { CurrencyValueConverter };
var LotteryToLookupValueConverter = /** @class */ (function () {
    function LotteryToLookupValueConverter() {
    }
    LotteryToLookupValueConverter.prototype.toView = function (value, items) {
        if (value && items) {
            var lottery = Enumerable.from(items).firstOrDefault(function (x) { return LotteryHelper.getLotteryKey(x.name ? x.name : x.lotteryName) == value; });
            return lottery;
        }
        return null;
    };
    LotteryToLookupValueConverter.prototype.fromView = function (value) {
        return value ? LotteryHelper.getLotteryKey(value.name) : '';
    };
    return LotteryToLookupValueConverter;
}());
export { LotteryToLookupValueConverter };
var ScratchcardToLookupValueConverter = /** @class */ (function () {
    function ScratchcardToLookupValueConverter() {
    }
    ScratchcardToLookupValueConverter.prototype.toView = function (value, items) {
        if (value && items) {
            var scratchcard = Enumerable.from(items).firstOrDefault(function (x) { return LotteryHelper.getLotteryKey(x.name ? x.name : x.name) == value; });
            return scratchcard;
        }
        return null;
    };
    ScratchcardToLookupValueConverter.prototype.fromView = function (value) {
        return value ? LotteryHelper.getLotteryKey(value.name) : '';
    };
    return ScratchcardToLookupValueConverter;
}());
export { ScratchcardToLookupValueConverter };
